const validate = (content, validators, trigger) => {
  const errors = [];
  validators.forEach((validator) => {
    if ((trigger === validator.trigger || validator.trigger === 'onChange') && !validator.test(content)) {
      errors.push({
        message: validator.message,
        severity: validator.severity
      });
    }
  });

  return errors;
};

export default validate;
